import { render, staticRenderFns } from "./ShopAggregation.vue?vue&type=template&id=87ac029e&scoped=true&"
import script from "./ShopAggregation.vue?vue&type=script&lang=js&"
export * from "./ShopAggregation.vue?vue&type=script&lang=js&"
import style0 from "./ShopAggregation.vue?vue&type=style&index=0&id=87ac029e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ac029e",
  null
  
)

export default component.exports